export default __webpack_public_path__ + "static/media/Kanami Dance photo.2a1be81d.jpg";